<template>
  <div class="maintenance-page">
    <div class="maintenance-card">
      <h1>Sitio en mantenimiento</h1>
      <p>
        Estamos realizando una pausa operativa temporal. Intenta nuevamente en unos minutos.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage',
}
</script>

<style scoped>
.maintenance-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(150deg, #f4f7fb 0%, #e5ebf6 100%);
}

.maintenance-card {
  width: 100%;
  max-width: 560px;
  border: 1px solid #d6dfef;
  border-radius: 12px;
  padding: 28px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(33, 52, 91, 0.14);
}

h1 {
  margin: 0 0 10px;
  color: #1f3157;
  font-size: 28px;
}

p {
  margin: 0;
  color: #516388;
  line-height: 1.55;
}
</style>
